"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var android_message_listener_1 = require("./android-message-listener");
var android_types_1 = require("./android-types");
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var AndroidLifecycle = (function (_super) {
    __extends(AndroidLifecycle, _super);
    function AndroidLifecycle(window) {
        var _this = _super.call(this) || this;
        _this.resumingObserver = new client_lib_js_player_addons_common_player_1.Observable();
        _this.suspendingObserver = new client_lib_js_player_addons_common_player_1.Observable();
        android_message_listener_1.AndroidMessageListener.getInstance(window).registerMessageListener('lifecycle', function (androidData) {
            switch (androidData) {
                case android_types_1.AndroidLifecycleMethod.OnPause:
                    return _this.suspendingObserver.notifyObservers();
                case android_types_1.AndroidLifecycleMethod.OnResume:
                    return _this.resumingObserver.notifyObservers();
                default:
                    return;
            }
        });
        return _this;
    }
    AndroidLifecycle.prototype.onResuming = function (handler) {
        this.resumingObserver.registerObserver(handler, this);
        return true;
    };
    AndroidLifecycle.prototype.onSuspending = function (handler) {
        this.suspendingObserver.registerObserver(handler, this);
        return true;
    };
    return AndroidLifecycle;
}(client_lib_js_player_addons_common_player_1.Lifecycle));
exports.AndroidLifecycle = AndroidLifecycle;
